import { useMemo } from 'react';
import { useAuth, ROLES } from '../contexts/AuthContext';
import { useSelectedCity } from '../contexts/SelectedCityContext';

/**
 * Retorna a "cidade efetiva" para filtrar listas no sistema.
 *
 * - Admin: usa a cidade SELECIONADA no sidebar (combobox). Se nenhuma estiver
 *   selecionada ("Todas as cidades"), retorna null → sem filtro (vê tudo).
 * - Demais perfis: usa a cidade vinculada ao próprio usuário.
 *
 * @returns {{id: number|string, name: string}|null}
 */
export function useEffectiveCity() {
  const { user, getUserCity } = useAuth();
  const { cities, selectedCityId } = useSelectedCity();
  const userCity = getUserCity();

  // Memoizado para preservar a referência entre renders (evita loops de
  // fetch em telas que usam a cidade efetiva como dependência de efeito).
  return useMemo(() => {
    if (user?.role === ROLES.ADMIN) {
      if (!selectedCityId) return null; // Todas as cidades
      const c = cities.find((x) => Number(x.id) === Number(selectedCityId));
      return { id: selectedCityId, name: c?.city || '' };
    }
    return userCity;
  }, [user?.role, selectedCityId, cities, userCity]);
}

export default useEffectiveCity;
